import { Validators } from '@angular/forms';
import { Form } from 'app/components/form/form';
import { PhoneNumberValidator } from 'app/utilities/phone-number-validator';

export class DialogMyProfileForm extends Form {

  formErrors = {
    'fullName': {},
    'companyName': {},
    'position': {},
    'date': {},
    'month': {},
    'year': {},
  };

  getInitForm = (fullName?: String,
    company?: String,
    position?: String,
    date?: any,
    month?: any,
    year?: any,
    timeOfBirth?: String) => {
    return {
      'fullName': [fullName, [Validators.required, Validators.pattern(this.validatePattern.fullName)]],
      'companyName': [{ value: company, disabled: !!company }, Validators.required],
      'position': [position],
      'date': [date, [Validators.required]],
      'month': [month , [Validators.required]],
      'year': [year , [Validators.required]],
      'timeOfBirth': [timeOfBirth, [Validators.required]]
    };
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/my-profile/dialog-my-profile/dialog-my-profile.form.ts